import { render, staticRenderFns } from "./IncidentViewCard.vue?vue&type=template&id=1bb45d94&scoped=true"
import script from "./IncidentViewCard.vue?vue&type=script&lang=js"
export * from "./IncidentViewCard.vue?vue&type=script&lang=js"
import style0 from "./IncidentViewCard.vue?vue&type=style&index=0&id=1bb45d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb45d94",
  null
  
)

export default component.exports